import IndiaOrGlobalModal from './IndiaOrGlobalModal';

export default IndiaOrGlobalModal;
